import { Component, Input } from '@angular/core';
import { DsNavigationBarModule } from '@bmw-ds/components';

@Component({
  selector: 'app-header',
  standalone: true,  // ✅ Mark it as standalone
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [], // Add any required modules here if needed
})
export class HeaderComponent {
  @Input() navBarRef!: DsNavigationBarModule;

  constructor() {}
}
